<template>
    <el-dialog title="煤源价格走势维护" :visible="visible" :show="show" width="40%" :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
            <el-form-item label="填报日期" class="input" prop="days" >
                <el-date-picker v-model="ruleForm.days" type="date" placeholder="请输入填报日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="热值" class="input" prop="hots" >
                <el-select v-model="ruleForm.hots" autocomplete="off" placeholder="请选择热值">
                    <el-option label="4500" value="4500"></el-option>
                    <el-option label="5000" value="5000"></el-option>
                    <el-option label="5500" value="5500"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="坑口报价" class="input" prop="minePrice" >
                <el-input v-model.number="ruleForm.minePrice" autocomplete="off" placeholder="请输入坑口报价"></el-input>
            </el-form-item>
            <el-form-item label="港口报价" class="input" prop="portPrice" >
                <el-input v-model.number="ruleForm.portPrice" autocomplete="off" placeholder="请输入港口报价"></el-input>
            </el-form-item>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    /*debugger;
                    if (this.rowData.id==undefined){
                        this.ruleForm.days = new Date();
                        this.$forceUpdate();
                    }*/
                }
            },
            rowData(){
                this.ruleForm = this.rowData;
                if (this.rowData.type=='info'){
                    this.updateBtn = false;
                }
            },
        },
        data(){
            return{
                updateBtn:true,
                url:base.get().url,
                visible:false,
                ruleForm:{
                    hots:'',
                    days:new Date(),
                    minePrice:null,
                    portPrice:null
                },
                rules:{
                    hots:[{ required: true, message: '请输入热值', trigger: 'blur' }],
                    days:[{ required: true, message: '请输入填报日期', trigger: 'blur' }],
                    minePrice:[{ required: true, message: '请输入坑口报价', trigger: 'blur' }],
                    portPrice:[{ required: true, message: '请输入港口报价', trigger: 'blur' }],
                },
            }
        },
        methods:{
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url:  this.ruleForm.id==''|| this.ruleForm.id==undefined?this.url+`cocalPriceChart/`+"save":this.url+`cocalPriceChart/`+"update",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "保存成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
        }
    }
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }

    .detail-form-content .el-form-item {
        margin-bottom: 20px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
        font-size: 14px;
    }

    .detail-form-content .el-form-item__content {
        line-height: normal;
    }

    .detail-form-content .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-select {
        width: 100%;
    }

    .detail-form-content .el-upload-list--picture-card .el-upload-list__item,
    .detail-form-content .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 126px;
        border-radius: 6px;
        border: 1px dashed #c0ccda;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-upload--picture-card:hover {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
    }

    .detail-form-content .el-upload--picture-card:hover i {
        color: var(--publicMainColor);
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .form-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
    }

    .detail-form-content .form-footer .el-button {
        min-width: 100px;
        border-radius: 4px;
    }

    .detail-form-content .form-footer .el-button--primary {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
    }

    .detail-form-content .form-footer .el-button--primary:hover {
        background-color: #2b5797;
        border-color: #2b5797;
    }

    .detail-form-content .form-footer .el-button--default:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.06);
    }
</style>